module.exports = __webpack_public_path__ + "img/logo_emara.972117d7.png";